import { AlertTypeEnums, EPricing, EProduct, ISubscription } from "@canei/app-components";
import { IPaymentFormProps } from "../../../../components/PaymentForm";

export interface IPaymentDialogContext {
  key: number;
  shouldSubmit: boolean;
  paymentForm: IPaymentFormProps;
  stateFor3DS2?: AlertTypeEnums;
}

export enum ECountry {
  AUT = "AUT",
  DEU = "DEU",
  CHE = "CHE",
}

export interface ICustomerData {
  customer_id: string;
  product_id: EProduct;
  pricing_id: EPricing;
  status: string;
  start_date: number;
  trial_end: number;
  canceled_at?: number;
  billing_address?: IBillingDetailedAddress;
  payment_method?: PaymentMethod;
}
export interface IBillingDetailedAddress {
  line_1?: string;
  line_2?: string;
  city?: string;
  email?: string;
  telephone?: string;
  postal?: string;
  country?: ECountry | string;
  name?: string;
  vat_id?: string;
}
export interface PaymentMethod {
  type?: string;
  last_four?: string;
  brand?: string;
  bank_code?: string;
  exp_month?: number;
  exp_year?: number;
}
export interface IGetCustomerStatus {
  getCustomerStatus: ICustomerData;
}

export interface IUpdateBillingAddressVars {
  params: IBillingDetailedAddress;
  customer_id: string;
}

export interface ISubscriptionData {
  result?: ISubscription[];
}
export interface ISubscriptionVars {
  customer_id: string;
}

export interface IGetCustomerPricing {
  getCustomerPricing: { price: number; trial_days: number };
}

export interface IGetCustomerPricingVar {
  pricing_id: string;
}

export interface IUpdateBillingAddressRetVal {
  updateBillingAddress: IBillingDetailedAddress;
}
